import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Singleton } from "../../../../../core/services/Singleton";
import { _IBCCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { WelfareEntityTypeConstantsSelector } from "../../../ParametrosTalentoHumano/ImportedPayrollBeneficiary/WelfareEntityTypeConstants";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";


interface Props {
    accountID: number;
}

export const IBCCatalog = ({ accountID }: Props) => {

    const ibc = useDataBean(_IBCCatalog);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
     const [form, setForm] = useState<any>({
      Year:null,
      Month:null,
WelfareType:null,
IBCValue:null
     })
    const [Year, setYear] = useState<number>(_single.getCurrenYear())
    const [month, setMonth] = useState<number>(_single.getCurrentMonth())
    const [modalentity, setModalentity] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modaltype, setModaltype] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [accountID])

    const getLista = () => {

        ibc.instance.getPayrollIBCCatalogByEmployee(accountID,Year,month).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        ibc.setBean({
            IDAccount: accountID
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ibc.instance.deleteVoid(ibc.bean.IDPayrollIBC).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        ibc.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    
     const addPayrollIBCentity = () => {
        ////console.log(SubMacroProcess.bean);
        ibc.instance.addPayrollIBC(form.Year,form.Month,accountID,form.WelfareType,form.IBCValue,_single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModalentity({ ...modalentity, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
     const addPayrollIBCtype = () => {
        
        ibc.instance.addPayrollIBCBool(form.Year,form.Month,accountID,form.IBCValue,_single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModaltype({ ...modaltype, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
   const verentity = () => {
        setModalentity({ ...modalentity, "view": true });
    }
      const vertype = () => {
        setModaltype({ ...modaltype, "view": true });
    }
    const head = [
        { title: 'ID', property: 'IDPayrollIBC', visible: true },
        { title: 'Vigencia', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Tipo Entidad', property: 'WelfareTypeName', visible: true },
        { title: 'Valor IBC', property: 'IBCValue', visible: true },
        { title: 'Actualiza', property: 'EmployeeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Definir IBC para Liquidación de Payroll</label>
            <div className="col-md-6">
                                <AccountantYear idSelector={Year} label="Año" onChange={(e) => { setYear(e) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthEditorbyconst idSelector={month} onChange={(e) => { setMonth(e) }} />
                            </div>
                            <div className="col-md-2 mt-3">
                                <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                                    Buscar
                                </BasicButton>
                            </div>
                            <div className="col-md-4 mt-3">
                                <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={verentity}>
                                        Agregar por Tipo de Entidad
                                </BasicButton>
                            </div>
                            <div className="col-md-6 mt-3">
                                <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={vertype}>
                                        Agregar para todos los Tipos de Entidad
                                </BasicButton>
                            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={ibc.setBean} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                                <AccountantYear idSelector={ibc.bean.Year} label="Año" onChange={(e: any) => { ibc.setBean({ ...ibc.bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthEditorbyconst idSelector={ibc.bean.Month} onChange={(e: any) => { ibc.setBean({ ...ibc.bean, "Month": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntityTypeConstantsSelector idSelector={ibc.bean.WelfareType} onChange={(e: any) => { ibc.setBean({ ...ibc.bean, "WelfareType": e }) }} />
                            </div>
                        <div className="col-md-12">
                            <label>Valor IBC</label>
                            <input type="text" name="IBCValue" className="form-control" value={ibc.bean.IBCValue} onChange={(e: any) => { ibc.setBean({ ...ibc.bean, "IBCValue": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
                 <Modal modal={modalentity} updateModal={setModalentity} eventModal={addPayrollIBCentity}>
                    <div className="row">
                       <div className="col-md-6">
                                <AccountantYear idSelector={form.Year} label="Año" onChange={(e: any) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthEditorbyconst idSelector={form.Month} onChange={(e: any) => { setForm({ ...form, "Month": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <WelfareEntityTypeConstantsSelector idSelector={form.WelfareType} onChange={(e: any) => { setForm({ ...form, "WelfareType": e }) }} />
                            </div>
                             <div className="col-md-12">
                            <label>Valor IBC</label>
                            <input type="text" name="IBCValue" className="form-control" value={form.IBCValue} onChange={(e: any) => { setForm({ ...form, "IBCValue": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modaltype} updateModal={setModaltype} eventModal={addPayrollIBCtype}>
                    <div className="row">
                       <div className="col-md-6">
                                <AccountantYear idSelector={form.Year} label="Año" onChange={(e: any) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthEditorbyconst idSelector={form.Month} onChange={(e: any) => { setForm({ ...form, "Month": e }) }} />
                            </div>
                            <div className="col-md-12">
                            <label>Valor IBC</label>
                            <input type="text" name="IBCValue" className="form-control" value={form.IBCValue} onChange={(e: any) => { setForm({ ...form, "IBCValue": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}